import { render, staticRenderFns } from "./ImagenesGrandes.vue?vue&type=template&id=5357ef0f"
import script from "./ImagenesGrandes.vue?vue&type=script&lang=js"
export * from "./ImagenesGrandes.vue?vue&type=script&lang=js"
import style0 from "./ImagenesGrandes.vue?vue&type=style&index=0&id=5357ef0f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports